/**
* Created by vouill on 3/14/18.
*/

<template>
  <div
    class="main"
    :style="{'background-image': `url(${imgMeta && imgMeta.file.url}`}">
    <div
      class="container">
      <div class="title">MÊTIS</div>
      <div class="subtitle">{{ slogan }}</div>
      <a
        href="http://eepurl.com/dkJx99"
        rel="noopener noreferrer"
        target="_blank"><b-button
          class="hvr-buzz-out"
          is-primary
          is-rounded>S'abonner à la newsletter !</b-button></a>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main {
  position: relative;
  transition: background-image 1s ease-in-out;
  display: flex;
  justify-content: center;
  align-items: center;
  background-size: cover;
  background-position: center;
  background-color: #f9f9f9;
  min-height: 300px;
}

.background {
  opacity: 0;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
.title {
  font-size: 60px;
  color: white;
  text-align: center;
  text-shadow: 0px 0px 8px #ababab;
}
.subtitle {
  color: white;
  text-shadow: 0px 0px 8px #ababab;
}
.container {
  width: 300px;
  text-align: center;
}
.button {
  font-size: 600;
  -webkit-user-select: none; /* Chrome all / Safari all */
  -moz-user-select: none; /* Firefox all */
  -ms-user-select: none; /* IE 10+ */
  user-select: none; /* Likely future */
}
</style>

<script>
import { getAsset } from "../../utils/contentful";

export default {
  name: "PictureIntro",
  props: { data: Object },
  computed: {
    slogan: function() {
      const { data } = this;
      const arr = data && data.items[0].fields.slogans;
      return arr && arr[Math.floor(Math.random() * arr.length)];
    },
    imgMeta: function() {
      const { data } = this;
      return (
        data &&
        getAsset(data.includes, data.items[0].fields.firstCoverImg.sys.id)
          .fields
      );
    }
  }
};
</script>
